import { installDatePicker } from './date-picker';
import { trackPointer } from './popup';
import { installSelectPicker } from './select-picker';

export { closePopup } from './popup';

let installed = false;

/**
 * Our own select lists and date/time panels for every field on the site (the browser only - call it from the app's
 * root once). Labels come from the page's language through t.
 */
export function installPickers(doc: Document, t: (key: string, fallback: string) => string): void {
    if (installed || !doc || !doc.defaultView) {
        return;
    }
    installed = true;
    const isTouch = trackPointer(doc);
    installSelectPicker(doc, isTouch, t);
    installDatePicker(doc, isTouch, t);
}
